import createIcon from '../../createIcon';

/**
 * @component @name ShortText
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCA5SDIwVjExSDRWOVpNNCAxM0gxNFYxNUg0VjEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ShortText = createIcon('ShortText', [
  ['path', { d: 'M4 9H20V11H4V9ZM4 13H14V15H4V13Z', key: 'cdrqsn' }],
]);

export default ShortText;
